import React, { useEffect } from "react";
import localData from "../../localData";
import { useGlobalContext } from "../../context";

export default function Modal({ isModalShown, setIsModalShown, dialogClassName,text, callback = () => {} }) {
    const { closer,  } = localData.svgs;
    const {  coffeeBreak } = localData.images;

    // CONFIG WITH NAVBAR
    const { setIsNavbarCollapsing, isNavbarShown } = useGlobalContext();

    useEffect(() => {
        if (isNavbarShown) setIsNavbarCollapsing(true);
        setTimeout(() => adaptLayouts(isModalShown), 100);
    }, [isModalShown]);
    //

    // CONFIG WITHOUT NAVBAR
    // useEffect(() => isModalShown && adaptLayouts(true), [isModalShown]);
    //

    const adaptLayouts = (isModified) => {
        const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth + "px";
        const navbar = document.querySelector(".navbar");
        if (isModified) {
            document.body.style.paddingRight = scrollbarWidth;
            document.body.style.overflow = "hidden";
            navbar.style.borderRight = `${scrollbarWidth} solid transparent`;
            return;
        }

        document.body.style.paddingRight = "";
        document.body.style.overflow = "";
        navbar.style.borderRight = "";
    };

    return (
        <div
            className={`modal fade ${isModalShown ? "show" : ""} `}
            id="exampleModal"
            tabIndex="-1"
            style={isModalShown ? { display: "block" } : {}}
            onClick={() => setIsModalShown(false)}
        >
            <div
                className={`modal-dialog ${dialogClassName ? dialogClassName : ""}`}
                onClick={(e) => e.stopPropagation()}
            >
                <div className="modal-content">
                    <button type="button" className="btn-close" onClick={() => setIsModalShown(false)}>
                        {closer}
                    </button>
                    <div className="modal-img">
                        <img src={coffeeBreak} alt="" />
                    </div>
                    <p className="modal-text">{text}</p>
                </div>
            </div>
        </div>
    );
}
